import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';

export type LiProps = NodeProps<{
  children: StructuredContent | StructuredContent[];
}>;

export function Li({ props }: LiProps) {
  return (
    <li className={'flex before:content-["•"] before:pr-4 [&:not(:last-child)]:mb-1'}>
      <StructuredContentRenderer doc={props.children} />
    </li>
  );
}
